import { Component, OnInit, TemplateRef } from '@angular/core';
import { HomeService } from '../../services/home.service';
import { environment } from 'src/environments/environment';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { ProductService } from 'src/app/product/services/product.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AlertService } from 'src/app/core/services/alert.service';
import { CartService } from 'src/app/cart/services/cart.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { Router } from '@angular/router';
import { SharedConsts } from 'src/app/shared/constants';

@Component({
    selector: 'product-listing-slider',
    templateUrl: './product-listing-slider.component.html',
    styleUrls: ['./product-listing-slider.component.scss'],
    standalone: false
})
export class ProductListingSliderComponent implements OnInit {
  imagePath = environment.s3_path + '/' + environment.product_image_folder + '/'
  slides = [];
  categoryMessage = '';
  popupMessage = ''
  miniCartDetails: any;
  commonBottonText: any = 'Ok';
  removeProduct = {};
  removeHeading = ''
  global_data:any = {};
  bsModalRef: BsModalRef;
  product_for_24_hr:any = {};
  totalCount = 0;
  payloadForNewProducts:any={
    'new':'1',
    'seasonal':'0',
    'productList':[],
    'nextPage':1,
    'totalProductCount':0,
    'totalProductPages':1,
    'CatSort':'',
    'sortBy':'short_desc',
    'promotionSelected':'',
    'brandSelected':'',
    'new_slider':true,
  }
  slideConfig = {
    "slidesToShow": 4,
    "slidesToScroll": 1,
    "dots": false,
    "infinite": false,
    "loop": true,
    "variableWidth": true,
    'responsive': [
      { 'breakpoint': 1700, 'settings': {'slidesToShow': 4}},
      { 'breakpoint': 1281, 'settings': {'slidesToShow': 3}},
      { 'breakpoint': 992, 'settings': {'slidesToShow': 2}},
      { 'breakpoint': 767, 'settings': {
        'slidesToShow': 2,
        "variableWidth": false,
      }}
    ]
  };
  slideConfig_mobile = {
    "slidesToShow": 4,
    "slidesToScroll": 1,
    "dots": true,
    "infinite": false,
    "loop": true,
    'responsive': [
      { 'breakpoint': 1700, 'settings': {'slidesToShow': 4}},
      { 'breakpoint': 1281, 'settings': {'slidesToShow': 3}},
      { 'breakpoint': 992, 'settings': {'slidesToShow': 2}},
      { 'breakpoint': 767, 'settings': {
        'slidesToShow': 2,
        "variableWidth": false,
      }},
      { 'breakpoint': 480, 'settings': {
        'slidesToShow': 1,
      }}
    ]
  };

  constructor(private homeService: HomeService, private statePersiste: StatePersistService,
    private productService: ProductService,
    private alertService: AlertService,
    private modalService: BsModalService, private cartService: CartService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private router: Router) { }

  ngOnInit(): void {
    this.statePersiste.watchGlobalDataStorage().subscribe(message => {
      this.global_data = this.statePersiste.getLocalStorage('global_data')
    })

    this.statePersiste.watchNewProductsStorage().subscribe(message => {
      this.newProductsSection()
    })
    this.newProductsSection()
    this.miniCartDetails = this.statePersiste.getLocalStorage('mini_cart_details')
    this.statePersiste.watchMiniCartDetailChange().subscribe(message => {
      this.miniCartDetails = this.statePersiste.getLocalStorage('mini_cart_details')
    })
  }

  newProductsSection(){
    this.homeService.newProductSection(this.payloadForNewProducts)
      .subscribe(
        data => {
          if (data.response) {
            let product_array = [];
            let products;
            products = data.response.products
            this.totalCount = data.response.total_product_count
            for (let i = 0; i < products.length; i++) {
              products[i]['img'] = this.imagePath + products[i].images[0]
              products[i]['productName'] = products[i].name
              products[i]['url'] = ['/product/detail',products[i].sku]
              products[i]['price_visibility'] = this.global_data['price_visibility']
              product_array.push(products[i])
            }
            this.slides = product_array
          }
        }
      );
  }

  redirectToProductDetail(url){
    this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_PRODUCT_DETAIL_NEWIN_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.HOME_PRODUCT_DETAIL_NEWIN_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.router.navigate([url[0]+'/'+url[1]]);

  }

  popup(template: TemplateRef<any>){
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
  }

  toInteger(value) {
    return parseInt(value)
  }

  addToCart(product, qyt, template: any, type: any, template2:any,popup_24hr_template:any,check_last_order=true) {
    this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_ADDTOCART_NEWIN_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.HOME_ADDTOCART_NEWIN_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    let dataObj; 
    if (product.qty == '') {
      qyt = '1'
    }

    if (!check_last_order){
      this.bsModalRef.hide();
    }

    this.miniCartDetails = this.statePersiste.getLocalStorage('mini_cart_details')
    if (this.miniCartDetails){
      if (this.miniCartDetails.items_count != '0' && this.miniCartDetails.items_count != ''){
        check_last_order = false
      }
    }
    dataObj = {
      "cart_item": {
        "sku": product.sku,
        "qty": qyt
      },
      "check_last_order":check_last_order,
    }
    this.productService.addToCart(dataObj)
      .subscribe(
        data => {
          if (data.response) {
            this.popupMessage = ''
            if (data.status == 2212) {
              for (let i = 0; i < this.slides.length; i++) {
                if (this.slides[i]['product_id'] == product.product_id) {
                  this.slides[i]['qty'] = '1'
                }}
              this.alertService.error(data.response.msg)
            }
            else if (data.status == 1169) {
              for (let i = 0; i < this.slides.length; i++) {
                if (this.slides[i]['product_id'] == product.product_id) {
                  this.slides[i]['qty'] = '1'
                  this.slides[i]['back_in_stock'] = '0'
                }
              }
            }
            else if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              document.getElementById("openclosedStoreInfo").click();
              for (let i = 0; i < this.slides.length; i++) {
                if (this.slides[i]['product_id'] == product.product_id) {
                  this.slides[i]['qty'] = '1'
                }
              
            }
            }
            else if (data.status == 1168) {
              for (let i = 0; i < this.slides.length; i++) {
                if (this.slides[i]['product_id'] == product.product_id) {
                  this.slides[i]['qty'] = '1'
                  this.slides[i]['back_in_stock'] = '0'
                }
              }
              this.popupMessage = data.response
              this.commonBottonText = "Ok, Don't show this again"
              this.popup(template2)
              
            }
            else if (data.status == 1163) {
              this.alertService.error(data.response)
              this.slides = this.slides.filter(item => item.product_id !== product.product_id);
              
            }
            else if (data.status == 1188) {
              this.product_for_24_hr = product
              this.popupMessage = data.response.split("<br>").join("\n");
              this.commonBottonText = "Confirm"
              this.popup(popup_24hr_template)
            }
            else {
              for (let i = 0; i < this.slides.length; i++) {
                if (this.slides[i]['product_id'] == product.product_id) {
                  this.slides[i]['qty'] = String(qyt)
                  this.slides[i]['item_id'] = data.response.item_id
                }
              }
              var storeCount
              storeCount = this.statePersiste.getLocalStorage('selectedStoreAddress')
              if (template && storeCount['totalStoreCount'] > 1){
                this.popup(template)
              }

            }
            this.statePersiste.emitminiCartData('min cart update')

          }

        }
      );
  }

  qytChange(product, qyt, template,template2: any, type:any) {
    this.statePersiste.amendQtyGoogleanalyticsEvent()
    if (product.item_id !== '') {
      if (qyt == 0){
        for (let i = 0; i < this.slides.length; i++) {
          if (this.slides[i]['product_id'] == product.product_id) {
            this.slides[i]['qty'] = 0
          }
        }
        this.removeItem(product)
      }else{
        this.qytUpdate(product, String(qyt), template)
      }
      
    }
    else {
      for (let i = 0; i < this.slides.length; i++) {
        if (this.slides[i]['product_id'] == product.product_id) {

          this.slides[i]['qty'] = String(qyt)
        }
      }
    }
  }

  qytUpdate(product, qyt, template) {
    this.productService.qytUpdate({ 'item_id': parseInt(product.item_id), 'qty': qyt })
      .subscribe(
        data => {
          if (data.response) {
            this.popupMessage = ''
            if (data.status == 1169) {
              for (let i = 0; i < this.slides.length; i++) {
                if (this.slides[i]['product_id'] == product.product_id) {
                  this.slides[i]['qty'] = '1'
                  this.slides[i]['item_id'] = ''
                  this.slides[i]['back_in_stock'] = '0'
                }
              }
            }
            else if (data.status == 2211){
              this.alertService.error(data.response)
              this.newProductsSection()
            }
            else if (data.status == 2212){
              this.alertService.error(data.response)
              for (let i = 0; i < this.slides.length; i++) {
                if (this.slides[i]['product_id'] == product.product_id) {
                  this.slides[i]['qty'] = data.response.qyt
                }
            }
            }
            else if(data.status == 1180){
                localStorage.setItem('closeStorInfoMessage', data.response.msg)
                document.getElementById("openclosedStoreInfo").click();
                for (let i = 0; i < this.slides.length; i++) {
                  if (this.slides[i]['product_id'] == product.product_id) {
                    this.slides[i]['qty'] = data.response.qyt
                  }
              }
              document.getElementById('spiner__btn_'+product.product_id).getElementsByTagName('div')[1].textContent = product.qty
              
            }
            else if (data.status == 1163) {
              this.alertService.error(data.response)
              this.slides = this.slides.filter(item => item.product_id !== product.product_id);
              this.totalCount = this.totalCount-1
              
            }
            else {
              for (let i = 0; i < this.slides.length; i++) {
                if (this.slides[i]['product_id'] == product.product_id) {
                  this.slides[i]['qty'] = qyt
                }
              }
            }
            this.statePersiste.emitminiCartData('min cart update')

          }

        }
      );
  }

  listClick(event, newValue, link) {
     this.statePersiste.setLocalStorage('product_data', {'brand_filter':''});
    this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_NEWIN_VIEW_ALL_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.HOME_NEWIN_VIEW_ALL_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.router.navigate([link])
}

  removePopup(template: TemplateRef<any>, selectedProduct) {
    this.removeProduct = selectedProduct
    this.removeHeading = 'Are you sure you want to remove product from cart?'
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
  }

  removeItem(product){
    let fordata;
    fordata = {'item_id': product.item_id}
    this.cartService.removeItem(fordata)
      .subscribe(
        data => {
          if (data.response) {
            if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              document.getElementById("openclosedStoreInfo").click();
            }
            else if (data.status == 2212){
              this.alertService.error(data.response)
            }
            else if (data.status == 2211){
              this.alertService.error(data.response)
              this.newProductsSection()
            }
            else{
              for (let i = 0; i < this.slides.length; i++) {
                if (this.slides[i]['product_id'] == product.product_id) {
                  this.slides[i]['back_in_stock'] = ''
                  this.slides[i]['item_id'] = ''
                }
              }
              this.statePersiste.emitminiCartData('update mini cart')
              this.alertService.success('Product removed.')
            }
            
          }
            
          }

      )

  }

}

